import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getAlGroupsForDropdown,
    getDivisionByEstateID,
    GetAllOperationEntityByGroupID,
    DailyFieldPerformanceReportData,
    GetAvialableFieldsForDropdown
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getDivisionByEstateID(operationEntityID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true && item[1]["operationEntityID"] == operationEntityID) {
            array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return array;
}

async function DailyFieldPerformanceReportData(data) {
    var model = {
        groupID: data.groupID,
        estateID: data.estateID,
        collectionPointID: data.divisionID,
        fieldID: data.fieldID,
        month: data.month + "-01"
    };
    const response = await CommonPost('/api/DailyFieldPerformanceReport/GetDataForDailyFieldPerformanceReport', null, model);
    return response.data;
}

async function GetAvialableFieldsForDropdown(divisionID) {
    var fieldArray = [];
    const response = await CommonGet('/api/DailyFieldPerformanceReport/GetFieldsByDivision', 'divisionID=' + parseInt(divisionID));
    for (let item of Object.entries(response.data)) {
        fieldArray[item[1]["fieldID"]] = item[1]["fieldName"]
    }
    return fieldArray;
}
